import React from 'react';

interface LoadingSpinnerProps {
  /** Spinner diameter in px. Default 48 */
  size?: number;
  /** Track colour. Default #E2E8F0 */
  trackColor?: string;
  /** Active colour. Default #1B3A6B */
  color?: string;
  /** Optional text shown below the spinner */
  label?: string;
  /** Border thickness. Default 4 */
  thickness?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 48,
  trackColor = '#E2E8F0',
  color = '#1B3A6B',
  label,
  thickness = 4,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
    <div
      style={{
        width: size,
        height: size,
        border: `${thickness}px solid ${trackColor}`,
        borderTop: `${thickness}px solid ${color}`,
        borderRadius: '50%',
        animation: 'arcaml-spin 1s linear infinite',
      }}
    />
    {label && <p style={{ color: '#64748B', fontSize: 13, margin: 0 }}>{label}</p>}
    <style>{`@keyframes arcaml-spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);
